(function() {
  function shuffleFeaturedProducts() {
    document.querySelectorAll('.menu-drawer__featured-content-list').forEach(function(list) {
      var items = Array.from(list.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        list.appendChild(items[j]);
        items.splice(j, 1);
      }
      Array.from(list.children).forEach(function(el, idx) {
        el.style.display = idx < 6 ? '' : 'none';
      });
    });
  }

  var details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'open' && details.hasAttribute('open')) {
        setTimeout(shuffleFeaturedProducts, 300);
      }
    });
  });

  observer.observe(details, { attributes: true });
})();
